"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDataContext = useDataContext;
exports.DataProvider = DataProvider;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var DataContext = (0, _react.createContext)(null);

function useDataContext() {
  var context = (0, _react.useContext)(DataContext);

  if (!context) {
    throw new Error('Do not use columns or items outside of data Context');
  }

  return context;
}

function DataProvider(_ref) {
  var children = _ref.children,
      items = _ref.items,
      columns = _ref.columns;

  var value = _react2.default.useMemo(function () {
    return {
      columns: columns,
      items: items
    };
  }, [columns, items]);

  return _react2.default.createElement(DataContext.Provider, {
    value: value
  }, children);
}